import React, { useEffect } from 'react';
import Config from "../utilities/config";
import constant from '../utilities/constants';
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import { formatCurrency, combineValues, formatDate, getValue, formatDatewithspecialcahracters, formatCurrencywithamount } from '../utilities/helper';
import { getOrderfailPage } from "../redux/action/orderAction";
import {
  getCartpagedata_count,
  apply_voucher, Update_cart_and_order_status,
  Add_To_Cart
} from "../redux/action/cartAction";
import config from '../utilities/config';
import Page404 from './Page404';
import constants from '../utilities/constants';
export default function PaymentFail() {
  const dispatch = useDispatch();
  const { orderid } = useParams();
  const { orderResponseFail, orderResponseFailError, orderfailResponesLoading } = useSelector((state) => state.orderReducer);
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const {
    userProfile_id,
    userProfile_email,
    loginModalType,
    authModalType,
    cartID,
  } = useSelector((state) => state.authReducer);
  useEffect(() => {
    dispatch(getOrderfailPage(orderid));
  }, [dispatch, orderid]);

  useEffect(() => {
    userProfile_id && dispatch(getCartpagedata_count(userProfile_id));
  }, [userProfile_id])

  useEffect(() => {
    if (orderResponseFail && orderResponseFail?.data?.data?.allOrders?.nodes[0]?.paymentStatus === 'Paid') {
      const pathSegments = window.location.href.split('/');
      const lastSegment = pathSegments[pathSegments.length - 1];
      //window.location.href = `/styloriSilver/paymentsuccess/${lastSegment}`;
    }
  }, [orderResponseFail])
  if (orderfailResponesLoading) {
    return (
      <div className="text-center py-6 flex flex-col items-center">
        {/* SVG Image from Path */}
        <img
          src={constants.DEFAULT_IMAGE + "/loaderimagesilver.gif"}
          alt="loading logo"
          className="w-120 h-120"
        />
      </div>
    );
  }

  if (!orderfailResponesLoading && orderResponseFail && (orderResponseFail?.data?.data?.allOrders?.nodes?.length === 0 || orderResponseFail?.data?.data?.allOrders?.nodes[0]?.paymentStatus === 'Paid')) {
    config.logGeneral && console.log("redirectto404page")
    return <Page404 />;
  }
  if (!orderfailResponesLoading && orderResponseFail && orderResponseFail?.data?.data?.allOrders?.nodes[0]) {
    const orderData = orderResponseFail?.data?.data?.allOrders?.nodes[0];
    const cartId_fail = orderData?.shoppingCartByCartId?.id;
    const shoppingCart = orderData.shoppingCartByCartId;
    const subtotal = shoppingCart?.discountedPrice || "NA";
    const formattedAmount = (subtotal !== "NA") ? subtotal : "0";
    //get the product info... from shoppingCartItemsByShoppingCartId
    const productInfo = orderData?.shoppingCartByCartId?.shoppingCartItemsByShoppingCartId?.nodes;
    const productName = combineValues(productInfo, 'transSkuListByProductSku.productListByProductId.productName', ' & ');
    const productskuIds = combineValues(productInfo, 'transSkuListByProductSku.generatedSku', ' & ');
    const discountPrice = combineValues(productInfo, 'transSkuListByProductSku.discountPrice', ',').split(",").reduce((acc, curr) => acc + parseFloat(curr), 0);
    const MarkPrice = combineValues(productInfo, 'transSkuListByProductSku.discountPrice', ',').split(",").reduce((acc, curr) => acc + parseFloat(curr), 0);
    const discountshow = Math.floor(discountPrice - MarkPrice).toLocaleString('en-IN');
    const orderdate = orderData?.createdAt;

    const shippingCharge = (shoppingCart?.shippingCharge || 0) || "Free";
    //DDth Month YYYY at HH:mm AM/PM
    const orderDate = orderdate && formatDate(orderdate, "DDth Month YYYY  HH:mm AM/PM");
    //DD-MM-YYYY
    const orderdateHeading = orderdate && formatDatewithspecialcahracters(orderdate, "DD/MM/YYYY");//formatDatewithspecialcahracters
    //ship by date
    const shipDate = orderdate && formatDate(orderdate, "DDth DayOfWeek", constant.shipping_days);
    //delivery date
    const deliveryDate = orderdate && formatDate(orderdate, "DD-MM-YYYY", constant.shipping_days);
    const allcartAddress = shoppingCart?.cartAddressesByCartId?.nodes;
    //shipping address
    const filteredAddresses = allcartAddress.filter(address => address.addressType === 1);
    if (filteredAddresses.length > 1) {
      filteredAddresses.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    const cartAddress = filteredAddresses[0];//shipping address
    var DeliveryAddress = filteredAddresses[0];
    //delivery address
    if (allcartAddress?.length > 1) {
      var filteredAddressesDelivery = allcartAddress?.filter(address => address.addressType === 2);
      if (filteredAddressesDelivery?.length > 1) {
        filteredAddressesDelivery?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt));
      }
      DeliveryAddress = filteredAddressesDelivery[0];
    }
    //compare cart date and current date...
    const givenDate = new Date(orderdate);
    const currentDate = new Date();
    // Normalize both dates to compare only the date part (ignoring time)
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const isToday = normalizeDate(currentDate).getTime() === normalizeDate(givenDate).getTime();
    const handleClick = (e) => {
      e.preventDefault();
      // if (isToday) {
      //   if (userProfile_id && cartID) {
      //     dispatch(Update_cart_and_order_status(userProfile_id, cartID));
      //   }
      //   setTimeout(() => {
      //     window.location.href = "/styloriSilver/checkout";
      //   }, 500);
      // } else {
      //   window.location.href = "/styloriSilver/contactus";
      // }
      if (userProfile_id && cartID) {
        let prodAdd = productInfo?.map(item => ({
          sku_id: item?.transSkuListByProductSku?.generatedSku,
          qty: item?.qty,
          price: item?.transSkuListByProductSku?.discountPrice
        }));        

        // dispatch(Update_cart_and_order_status(userProfile_id, cartID));
        dispatch(Add_To_Cart(userProfile_id, prodAdd, null));
        dispatch(getCartpagedata_count(userProfile_id));        
      }
      setTimeout(() => {
        window.location.href = "/styloriSilver/checkout";
      }, 500);
    };
    return (
      <>
        <div className="bg-custom-gradient-fail">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-12">
              <div className="col-span-12">
                <div className='pt-9 pb-14'>
                  <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" className='mx-auto'>
                    <path d="M56.0591 56.5591C66.3088 46.3094 66.3088 29.6913 56.0591 19.4416C45.8093 9.1919 29.1913 9.1919 18.9416 19.4416C8.69185 29.6913 8.69185 46.3094 18.9416 56.5591C29.1913 66.8088 45.8093 66.8088 56.0591 56.5591Z" fill="#E33838" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M63.7551 42.4537C61.8873 53.3824 53.2645 62.0048 42.3361 63.8727L28.2048 49.7413C24.8232 46.9506 22.668 42.7273 22.668 38.0006C22.668 29.5974 29.4798 22.7855 37.883 22.7855C42.6098 22.7855 46.8331 24.9409 49.6238 28.3223L63.7551 42.4537Z" fill="#AC2727" />
                    <circle cx="37.3828" cy="38.0004" r="15" fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M37.3824 40.1224L42.6854 45.4254C42.9668 45.7067 43.3485 45.8648 43.7464 45.8648C44.1444 45.8648 44.526 45.7067 44.8074 45.4254C45.0888 45.144 45.2469 44.7623 45.2469 44.3644C45.2469 43.9664 45.0888 43.5847 44.8074 43.3034L39.5024 38.0004L44.8064 32.6974C44.9457 32.558 45.0561 32.3926 45.1315 32.2106C45.2068 32.0286 45.2456 31.8335 45.2455 31.6365C45.2455 31.4395 45.2066 31.2444 45.1312 31.0625C45.0558 30.8805 44.9452 30.7151 44.8059 30.5759C44.6666 30.4366 44.5012 30.3261 44.3192 30.2508C44.1371 30.1754 43.9421 30.1367 43.7451 30.1367C43.5481 30.1368 43.353 30.1756 43.171 30.2511C42.989 30.3265 42.8237 30.437 42.6844 30.5764L37.3824 35.8794L32.0794 30.5764C31.9411 30.433 31.7757 30.3187 31.5927 30.24C31.4097 30.1613 31.2129 30.1198 31.0137 30.118C30.8146 30.1162 30.617 30.154 30.4327 30.2294C30.2483 30.3047 30.0807 30.416 29.9398 30.5568C29.7989 30.6975 29.6875 30.865 29.612 31.0493C29.5365 31.2336 29.4984 31.4311 29.5001 31.6302C29.5017 31.8294 29.543 32.0263 29.6215 32.2093C29.7 32.3923 29.8142 32.5579 29.9574 32.6964L35.2624 38.0004L29.9584 43.3044C29.8152 43.4428 29.701 43.6084 29.6225 43.7914C29.544 43.9744 29.5027 44.1713 29.5011 44.3705C29.4994 44.5696 29.5375 44.7671 29.613 44.9514C29.6885 45.1358 29.7999 45.3032 29.9408 45.4439C30.0817 45.5847 30.2493 45.696 30.4337 45.7714C30.618 45.8467 30.8156 45.8846 31.0147 45.8827C31.2139 45.8809 31.4107 45.8394 31.5937 45.7607C31.7767 45.682 31.9421 45.5677 32.0804 45.4244L37.3824 40.1224Z" fill="#AC2727" />
                  </svg>
                  <p className='font-tiemann text-center font-bold text-[#222222] my-2 text-[26px]'>"Oops! Your Payment Failed"</p>
                  {/* <p className='text-center text-lg'>Your order <span className='text-teal-500 text-base font-bold'>#{orderData.id}</span> has been successfully placed.</p> */}
                  <p className='text-center font-light text-[#222222] text-base'>We couldn't process your payment. Don't worry, you can try again or use a different payment method.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white" >
          <div className="container mx-auto lg:px-28 px-5 2xl:mb-10">
            <div className="lg:grid lg:grid-flow-col xs:grid-cols-12 gap-4">
              <div className="lg:col-span-2 sm:col-span-1 lg:mb-0 xs:mb-2">
                <div className='border-solid border border-slate-300 lg:px-7 lg:py-11 sm:px-7 sm:py-8 px-5 py-4 lg:mb-0 mb-4'>
                  <p className=' flex items-center gap-2 font-medium text-xl text-[#222222] mb-3 justify-center'>Your Payment Has Failed</p>
                  <div className='flex mb-3 justify-center'>
                    <h3 className=' font-bold text-sm text-[#222222]'>Attempted Amount: <span className='font-normal'>{formatCurrencywithamount(
                      formattedAmount,
                      (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
                      (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                    )}</span></h3>
                    <h3 className=' font-bold text-sm text-[#222222] pl-10'>Date: <span className='font-normal'>{orderdateHeading}</span></h3>
                  </div>
                  <div className='flex lg:items-center items-end justify-center'>
                    <p className=' font-normal text-sm text-[#222222]'>Please check your payment details or contact your bank for further assistance</p>
                    <a className='text-[#06ab9f] font-bold text-sm border border-[#06ab9f] py-2 px-3 ml-5'
                      onClick={handleClick}
                    >
                      <button>
                        Try Again
                      </button>
                    </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='text-center mb-7'>
            <button className="lg:w-1/4 w-1/2 text-white lg:text-base text-sm text-center py-2 lg:px-10 px-0 bg-customGreen border border-customLightGreen duration-300">
              <a className='font-bold text-sm border border-[#06ab9f] py-2 px-3 ml-5 text-white' onClick={handleClick}>
                {/* {isToday ? `Go To Checkout` : `Go To Contact Us`} */}
                {`Go To Checkout`}
              </a>
            </button>
          </div>
          <div className='text-center mb-7 mt-5'>
            <h5 className='text-[#20B4A9] text-sm font-normal pb-3'>Thank you for shopping with us!</h5>
            <p className='text-[#8F8F8F] text-sm font-normal'>We look forward to serving you again.</p>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="bg-white-500 text-black text-center p-6">No data available for this order.</div>
    );
  }
}